const shared = {
    router: {
        url: process.env.REPLACE_MENU_PART_WEB_COM,
        menuUrl: process.env.REPLACE_MENU_PART_WEB,
    },
}

export { shared }
